import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const services = [
  {
    icon: 'ri-bar-chart-line',
    title: 'Conseil en gestion',
    description:
      "Accompagnement dans l'organisation et la gestion de votre activité pour une structure solide et efficace.",
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Conseil stratégique',
    description:
      "Aide à la prise de décision et au développement de l'entreprise avec une vision claire et structurée.",
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Optimisation des activités',
    description:
      "Analyse approfondie et amélioration des performances pour maximiser l'efficacité de votre organisation.",
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e62ded05a1c31347f8cef87dd8ce7d03.jpg"
            alt="BONIEK Conseil en gestion Bordeaux"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0d1e33]/70 via-[#0d1e33]/60 to-[#0d1e33]/75"></div>
        </div>

        <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/60 mb-6">
            Bordeaux · France · 70.22Z
          </p>
          <h1 className="text-4xl md:text-6xl font-light text-white leading-tight mb-6 tracking-tight">
            Conseil en gestion et<br />
            <span className="font-semibold">développement d&apos;entreprise</span>
          </h1>
          <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed mb-10">
            BONIEK accompagne les entrepreneurs et les entreprises dans le développement et l&apos;organisation de leur activité. Des solutions claires, efficaces et adaptées à chaque situation.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="whitespace-nowrap px-8 py-3.5 rounded-md bg-white text-[#1a2e4a] text-sm font-semibold hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
            >
              Contactez-nous
            </Link>
            <Link
              to="/a-propos"
              className="whitespace-nowrap px-8 py-3.5 rounded-md border border-white/40 text-white text-sm font-medium hover:bg-white/10 transition-colors duration-200 cursor-pointer"
            >
              En savoir plus
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
          <span className="w-6 h-6 flex items-center justify-center"><i className="ri-arrow-down-line text-white/50 text-xl"></i></span>
        </div>
      </section>

      {/* Services */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#1a2e4a]/50 mb-3">Nos services</p>
            <h2 className="text-3xl md:text-4xl font-light text-[#1a2e4a] tracking-tight">
              Un accompagnement <span className="font-semibold">sur mesure</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.title}
                className="group p-8 rounded-lg border border-gray-100 bg-[#fafafa] hover:border-[#1a2e4a]/20 hover:bg-white transition-all duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-[#1a2e4a]/8 mb-6">
                  <i className={`${service.icon} text-[#1a2e4a] text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-[#1a2e4a] mb-3">{service.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Approche */}
      <section className="py-24 bg-[#f5f4f2]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#1a2e4a]/50 mb-4">Notre approche</p>
              <h2 className="text-3xl md:text-4xl font-light text-[#1a2e4a] leading-tight mb-6 tracking-tight">
                Méthode, rigueur<br />
                <span className="font-semibold">et solutions concrètes</span>
              </h2>
              <p className="text-sm text-gray-500 leading-relaxed mb-8">
                Chaque mission est réalisée avec sérieux et méthode afin d&apos;apporter des solutions concrètes et adaptées aux besoins du client. L&apos;objectif est de comprendre en profondeur chaque situation pour proposer un accompagnement véritablement personnalisé.
              </p>
              <ul className="flex flex-col gap-4 mb-10">
                {[
                  'Analyse approfondie de votre situation',
                  'Recommandations claires et actionnables',
                  'Suivi et ajustement continu',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-gray-600">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#1a2e4a]/10">
                      <i className="ri-check-line text-[#1a2e4a] text-xs"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                to="/a-propos"
                className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-[#1a2e4a] hover:gap-3 transition-all duration-200 cursor-pointer"
              >
                Découvrir BONIEK
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </Link>
            </div>
            <div className="relative">
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20business%20consultant%20woman%20working%20at%20elegant%20desk%20in%20modern%20Bordeaux%20office%2C%20reviewing%20documents%20and%20strategy%20plans%2C%20sophisticated%20minimalist%20interior%20design%2C%20warm%20natural%20light%2C%20dark%20navy%20blue%20accents%2C%20clean%20professional%20atmosphere%2C%20high-end%20consulting%20environment&width=700&height=520&seq=approach-boniek-002&orientation=landscape"
                  alt="Approche conseil BONIEK Bordeaux"
                  className="w-full h-[380px] object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-lg p-5 hidden lg:block">
                <p className="text-xs text-gray-400 uppercase tracking-widest mb-1">Basé à</p>
                <p className="text-sm font-semibold text-[#1a2e4a]">Bordeaux, France</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-[#1a2e4a]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {[
              { value: '3', label: 'Domaines d\'expertise', suffix: '' },
              { value: '100', label: 'Engagement client', suffix: '%' },
              { value: '1', label: 'Interlocuteur dédié', suffix: '' },
            ].map((stat) => (
              <div key={stat.label} className="py-6">
                <p className="text-5xl font-light text-white mb-2">
                  {stat.value}<span className="text-3xl">{stat.suffix}</span>
                </p>
                <p className="text-sm text-white/50 uppercase tracking-widest">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#1a2e4a]/50 mb-4">Passons à l&apos;action</p>
          <h2 className="text-3xl md:text-4xl font-light text-[#1a2e4a] mb-6 tracking-tight">
            Prêt à développer<br />
            <span className="font-semibold">votre entreprise ?</span>
          </h2>
          <p className="text-sm text-gray-500 max-w-xl mx-auto mb-10 leading-relaxed">
            Contactez-nous pour échanger sur votre projet. Nous étudierons ensemble les meilleures solutions pour votre activité.
          </p>
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-[#1a2e4a] text-white text-sm font-semibold hover:bg-[#243d61] transition-colors duration-200 cursor-pointer"
          >
            Contactez-nous
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
